import z from 'zod';

export const validationCopy = {
    email: 'Enter a valid email address (e.g., name@example.com)',
} as const;

export const requestPasswordResetSchema = z.object({
    email: z.email(validationCopy.email).min(1, validationCopy.email),
});

export type RequestPasswordResetValues = z.input<typeof requestPasswordResetSchema>;
